module.exports = __webpack_public_path__ + "static/media/icon_dictionary_blue.3913d1ae.svg";